import { namespace } from 'vuex-class';
import { IIntegrationState } from '@/settings/integrations/store/integrations.types';

export const Integrations = namespace('settings/integrations');

export enum EIntegrationActions {
  LoadStatus = 'loadStatuses',
  LoadStatusSuccess = 'loadStatusesSuccess',
  LoadStatusFailed = 'loadStatusesFailed',
  LoadDetails = 'loadDetails',
  LoadDetailsSuccess = 'loadDetailsSuccess',
  LoadDetailsFailed = 'loadDetailsFailed',
  SetDetails = 'setDetails',
  SetDetailsSuccess = 'setDetailsSuccess',
  SetDetailsFailed = 'setDetailsFailed',
  Disconnect = 'disconnect',
  DisconnectSuccess = 'disconnectSuccess',
  DisconnectFailed = 'disconnectFailed',
  Reset = 'reset',
  ResetModalMeta = 'resetModalMeta',
  SetModalMeta = 'setModalMeta',
  ValidateLimeCrmFields = 'validateLimeCrmFields',
  ValidateLimeCrmFieldsSuccess = 'validateLimeFieldsCrmSuccess',
  ValidateLimeCrmFieldsFailed = 'validateLimeCrmFieldsFailed',
  GenerateInputData = 'generateInputData',
  GenerateInputDataSuccess = 'generateInputDataSuccess',
  GenerateInputDataFailed = 'generateInputDataFailed',
  VerifyPhone = 'verifyPhone',
  VerifyPhoneSuccess = 'verifyPhoneSuccess',
  VerifyPhoneFailed = 'verifyPhoneFailed',
}

export enum EIntegrationMutations {
  SetIntegrations = 'setIntegrations',
  SetLoading = 'setLoading',
  SetLoaded = 'setLoaded',
  SetState = 'setState',
  SetModalMeta = 'setModalMeta',
  SetPhoneValidationCode = 'setPhoneValidationCode',
  SetModalStep = 'setModalStep',
}

export const state: IIntegrationState = {
  status: [],
  loading: false,
  loaded: false,
  phoneValidationCode: '',
  modalStep: 1,
  details: {
    externalUrl: '',
    haveToken: '',
    identifier: '',
    metaData1: '',
    metaData2: '',
    metaData3: '',
    name: '',
    profile: '',
    status: '',
    userId: '',
    limeFields: [],
    token: '',
  },
};
